import { render, staticRenderFns } from "./episodeCard.vue?vue&type=template&id=61732cd0&scoped=true"
import script from "./episodeCard.vue?vue&type=script&lang=js"
export * from "./episodeCard.vue?vue&type=script&lang=js"
import style0 from "./episodeCard.vue?vue&type=style&index=0&id=61732cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61732cd0",
  null
  
)

export default component.exports